export const pages = {
    home: {
        name: "Front Page",
        url: "/",
        priority: 0,
    },
    us: {
        name: "US",
        url: "/us",
        priority: 1,
    },
    world: {
        name: "World",
        url: "/world",
        priority: 1,
    },
    politics: {
        name: "Politics",
        url: "/politics",
        priority: 1,
    },
    business: {
        name: "Business",
        url: "/business",
        priority: 1,
    },
    opinion: {
        name: "Opinion",
        url: "/opinion",
        priority: 2,
    },
    health: {
        name: "Health",
        url: "/health",
        priority: 2,
    },
};
